import PageHeaderBlock from '@/registry/evo-shadcn/blocks/page-header';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Calendar } from 'lucide-react';

export function GanttPage() {
  return (
    <div className="space-y-6">
      <PageHeaderBlock
        title="Gantt Charts"
        subtitle="Visual project planning with interactive timeline"
        size={20}
        showActions={false}
      />

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Calendar className="h-5 w-5 text-indigo-600" />
            Project Timeline
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            This feature is coming in Q2 2025. Check Feature Labs for preview access.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
